<template>
  <div>
    <a-upload
      :fileList="fileList"
      listType="picture-card"
      :multiple="true"
      :customRequest="customRequest"
      @change="onChange"
      @preview="handlePreview"
    >
      <div>
        <a-icon type="plus" />
        <div>{{ $t("上传") }}</div>
      </div>
    </a-upload>

    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import { materialImageUpload } from "@/api/material";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  props: ["initialItems"],
  model: { prop: "value", event: "change" },
  data() {
    return {
      fileList: [],
      previewVisible: false,
    };
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    customRequest({ file, onError, onSuccess }) {
      const dataForm = new FormData();
      dataForm.append("file", file);

      materialImageUpload(dataForm)
        .then((data) => onSuccess(data))
        .catch(() => onError({ name: this.$t("错误"), message: this.$t("上传错误") }));
    },
    onChange({ fileList }) {
      this.fileList = fileList;
      const fileSet = [];
      for (const fileItem of fileList) {
        if (fileItem.status === "done") {
          fileSet.push(fileItem.response.id);
        }
      }

      this.$emit("change", fileSet);
    },
  },
  mounted() {
    const fileItems = [];
    if (this.initialItems) {
      for (const item of this.initialItems) {
        fileItems.push({
          uid: `-${Date.now() * Math.random()}`,
          name: item.name,
          status: "done",
          url: item.file,
          response: item,
        });
      }
    }

    this.fileList = fileItems;
  },
};
</script>
